import {Box, Divider} from '@mui/material';
import {useId} from 'react';
import Highlight from './Highlight.tsx';
import {
  useGetConfigurationCollections,
  useGetConfigurationLayers,
} from '@src/api/configurations.ts';
import useVisualizationParams from '@src/hooks/useVisualizationParams.ts';
import dimensions from '@src/styles/dimensions.ts';
import {HighlightMemberWithCollection} from '@src/types/configurations.ts';

export const Highlights = () => {
  const {configurationId, collectionId} = useVisualizationParams();
  const {collections} = useGetConfigurationCollections(configurationId);
  const firstCollectionId = collections[0]?.id;
  const selectedCollectionId = collectionId ?? firstCollectionId;
  const {data} = useGetConfigurationLayers(configurationId);
  const titleId = useId();

  const highlights = data
    ?.filter(layer => {
      return !!layer.highlights;
    })
    .map(layer => {
      return (
        layer.highlights?.member.map(member => {
          return {
            ...member,
            collectionId: layer.collectionId,
          } as HighlightMemberWithCollection;
        }) ?? []
      );
    })
    .flat()
    .filter(member => {
      return selectedCollectionId === member.collectionId;
    });

  return highlights?.length ? (
    <>
      <Divider sx={{marginBlockStart: 3, marginBlockEnd: 2}} />
      <Box
        id={titleId}
        component="h3"
        sx={{
          typography: 'caption',
          marginBlockEnd: 1,
          marginInline: `${dimensions.leftSidebar.contentMargin}px`,
          color: 'text.secondary',
        }}
      >
        HIGHLIGHTS for selected data collection
      </Box>
      <Box
        aria-labelledby={titleId}
        component="section"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {highlights.map(highlight => (
          <Highlight key={highlight.id} highlight={highlight} />
        ))}
      </Box>
    </>
  ) : null;
};

export default Highlights;
